import { AI_ASSISTANTS, EDITOR_MODES } from '../../consts'
import { get } from 'lodash'

const vueReplacementMap = [
  {
    trigger: 'common',
    displayText: '<common-archor-button>',
    replaceText: `<common-anchor-button url="url" :popup="true" name="button_name" />`,
  },
  {
    trigger: 'el-row',
    displayText: '<el-row>',
    replaceText: `<el-row :gutter="20">
  <el-col :span="8">Column 1</el-col>
  <el-col :span="8">Column 2</el-col>
  <el-col :span="8">Column 3</el-col>
</el-row>`,
  },
  {
    trigger: 'el-col',
    displayText: '<el-col>',
    replaceText: `<el-row :gutter="20">
  <el-col :span="12">Column 1</el-col>
  <el-col :span="12">Column 2</el-col>
</el-row>`,
  },
  {
    trigger: 'el-container',
    displayText: '<el-container>',
    replaceText: `<el-container>
  <el-header>Header</el-header>
  <el-main>Main Content</el-main>
  <el-footer>Footer</el-footer>
</el-container>`,
  },
  {
    trigger: 'el-header',
    displayText: '<el-header>',
    replaceText: `<el-header>Header Content</el-header>`,
  },
  {
    trigger: 'el-main',
    displayText: '<el-main>',
    replaceText: `<el-main>Main Content</el-main>`,
  },
  {
    trigger: 'el-footer',
    displayText: '<el-footer>',
    replaceText: `<el-footer>Footer Content</el-footer>`,
  },
  {
    trigger: 'el-button',
    displayText: '<el-button>',
    replaceText: `<el-button type="primary">Primary Button</el-button>`,
  },
  {
    trigger: 'el-input',
    displayText: '<el-input>',
    replaceText: `<el-input placeholder="Enter text" />`,
  },
  {
    trigger: 'el-select',
    displayText: '<el-select>',
    replaceText: `<el-select v-model="value">
  <el-option label="Option 1" value="1"></el-option>
  <el-option label="Option 2" value="2"></el-option>
</el-select>`,
  },
  {
    trigger: 'el-card',
    displayText: '<el-card>',
    replaceText: `<el-card>
  <div slot="header" class="clearfix">
    <span>Card Title</span>
  </div>
  <div>Card Content</div>
</el-card>`,
  },
  {
    trigger: 'el-table',
    displayText: '<el-table>',
    replaceText: `<el-table :data="tableData">
  <el-table-column prop="date" label="Date" width="180"></el-table-column>
  <el-table-column prop="name" label="Name" width="180"></el-table-column>
  <el-table-column prop="address" label="Address"></el-table-column>
</el-table>`,
  },
  {
    trigger: 'el-form',
    displayText: '<el-form>',
    replaceText: `<el-form :model="form">
  <el-form-item label="Username">
    <el-input v-model="form.username"></el-input>
  </el-form-item>
  <el-form-item label="Password">
    <el-input type="password" v-model="form.password"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary">Submit</el-button>
  </el-form-item>
</el-form>`,
  },
  {
    trigger: 'el-dialog',
    displayText: '<el-dialog>',
    replaceText: `<el-dialog title="Dialog Title" :visible.sync="dialogVisible">
  <span>This is a dialog</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">Cancel</el-button>
    <el-button type="primary" @click="dialogVisible = false">Confirm</el-button>
  </span>
</el-dialog>`,
  },
  {
    trigger: 'el-tooltip',
    displayText: '<el-tooltip>',
    replaceText: `<el-tooltip content="Tooltip text" placement="top">
  <el-button>Hover me</el-button>
</el-tooltip>`,
  },
  {
    trigger: 'el-date-picker',
    displayText: '<el-date-picker>',
    replaceText: `<el-date-picker v-model="date" type="date" placeholder="Pick a date"></el-date-picker>`,
  },
  {
    trigger: 'el-pagination',
    displayText: '<el-pagination>',
    replaceText: `<el-pagination
      background
      layout="prev, pager, next"
      :total="100">
    </el-pagination>`,
  },
]

const expressionReplacementMap = [
  {
    trigger: 'query',
    displayText: 'query',
    replaceText: `query("query_name",[params],"FULL_RESULT")`,
  },
  {
    trigger: 'field',
    displayText: 'field',
    replaceText: `field("fieldName", { path: 'value', index: null })`,
  },
  {
    trigger: 'user',
    displayText: 'user',
    replaceText: `user({ path: 'id' })`,
  },
  {
    trigger: 'param',
    displayText: 'param',
    replaceText: `param("path")`,
  },
  {
    trigger: 'core',
    displayText: 'core',
    replaceText: `core("path")`,
  },
  {
    trigger: 'userFunctions',
    displayText: 'userFunctions',
    replaceText: `userFunctions("fnName", params)`,
  },
  {
    trigger: 'nextSequence',
    displayText: 'nextSequence',
    replaceText: `nextSequence("name")`,
  },
  {
    trigger: 'concat',
    displayText: 'concat',
    replaceText: `concat(params)`,
  },
  {
    trigger: 'result',
    displayText: 'result',
    replaceText: `result(value)`,
  },
  {
    trigger: 'sqlParams',
    displayText: 'sqlParams',
    replaceText: `core("sqlParams.")`,
  },
]

const processReplacementMap = [
  {
    trigger: 'find',
    displayText: 'find',
    replaceText: `Model.find(filter, callback)`,
  },
  {
    trigger: 'findOne',
    displayText: 'findOne',
    replaceText: `Model.findOne(filter, callback)`,
  },
  {
    trigger: 'create',
    displayText: 'create',
    replaceText: `Model.create(data, callback)`,
  },
  {
    trigger: 'updateAll',
    displayText: 'updateAll',
    replaceText: `Model.updateAll(where, data, callback)`,
  },
  {
    trigger: 'updateAttributes',
    displayText: 'updateAttributes',
    replaceText: `instance.updateAttributes(data, callback)`,
  },
  {
    trigger: 'upsert',
    displayText: 'upsert',
    replaceText: `Model.upsert(data, callback)`,
  },
  {
    trigger: 'upsertWithWhere',
    displayText: 'upsertWithWhere',
    replaceText: `Model.upsertWithWhere(where, data, callback)`,
  },
  {
    trigger: 'deleteById',
    displayText: 'deleteById',
    replaceText: `Model.deleteById(id, callback)`,
  },
  {
    trigger: 'count',
    displayText: 'count',
    replaceText: `Model.count(where, callback)`,
  },
  {
    trigger: 'exists',
    displayText: 'exists',
    replaceText: `Model.exists(id, callback)`,
  },
  {
    trigger: 'findById',
    displayText: 'findById',
    replaceText: `Model.findById(id, filter, callback)`,
  },
  {
    trigger: 'replaceById',
    displayText: 'replaceById',
    replaceText: `Model.replaceById(id, data, callback)`,
  },
  {
    trigger: 'replaceOrCreate',
    displayText: 'replaceOrCreate',
    replaceText: `Model.replaceOrCreate(data, callback)`,
  },
  {
    trigger: 'findOrCreate',
    displayText: 'findOrCreate',
    replaceText: `Model.findOrCreate(filter, data, callback)`,
  },
  {
    trigger: 'formFields',
    displayText: 'this.instance.form.fields',
    replaceText: 'this.instance.form.fields',
  },
  {
    trigger: 'nextSequence',
    displayText: 'nextSequence',
    replaceText: 'await nextSequence()',
  },
  {
    trigger: 'context',
    displayText: 'instance.context.set()',
    replaceText: 'instance.context.set("key",value)',
  },
  {
    trigger: 'context',
    displayText: 'instance.context.get()',
    replaceText: 'instance.context.get("key")',
  },
  {
    trigger: 'build',
    displayText: 'build("MODEL_NAME")',
    replaceText: 'build("MODEL_NAME")',
  },
  {
    trigger: 'paymentDataContext',
    displayText: "this.instance.context.set('paymentData', { ... })",
    replaceText:
      "this.instance.context.set('paymentData', {\n    payment_customer_email: '',\n    payment_amount: '',\n    payment_order_ref: '',\n    payment_redirect_url: '',\n    payment_invoice_name: '',\n    payment_invoice_company: '',\n    payment_invoice_country: '',\n    payment_invoice_state: '',\n    payment_invoice_city: '',\n    payment_invoice_zip: '',\n    payment_invoice_address: '',\n    payment_invoice_address2: '',\n    payment_invoice_phone: ''\n  })",
  },
]

export function getCompletions(
  lang = EDITOR_MODES.JAVASCRIPT,
  assistant = AI_ASSISTANTS.EXPRESSION_HELPER,
  completionSources = {}
) {
  //LAYOUT
  if (lang === EDITOR_MODES.HTML_MIXED) {
    return vueReplacementMap
  }
  //EXPRESSION
  if (lang === EDITOR_MODES.JAVASCRIPT && assistant === AI_ASSISTANTS.EXPRESSION_HELPER) {
    let combinedReplacementMap = expressionReplacementMap
    const formFields = get(completionSources, 'formFields', [])
    const userSnippets = get(completionSources, 'userSnippets', [])
    const queryParams = get(completionSources, 'queryParams', [])

    //FormFields
    if (formFields.length) {
      const formFieldReplacements = formFields.map((formField) => {
        return {
          trigger: formField.name,
          displayText: formField.name,
          replaceText: `field("${formField.name}")`,
        }
      })

      combinedReplacementMap = combinedReplacementMap.concat(formFieldReplacements)
    }

    //UserSnippets
    if (userSnippets.length) {
      const userSnippetsReplacements = userSnippets.map((snippet) => {
        return {
          trigger: snippet.name,
          displayText: snippet.name,
          replaceText: snippet.code,
        }
      })

      combinedReplacementMap = combinedReplacementMap.concat(userSnippetsReplacements)
    }

    //QueryParams
    if (queryParams.length) {
      const queryParamsReplacements = queryParams.map((queryParam) => {
        return {
          trigger: queryParam.name,
          displayText: queryParam.name,
          replaceText: `query('${queryParam.name}',[],'FULL_RESULT')`,
        }
      })

      combinedReplacementMap = combinedReplacementMap.concat(queryParamsReplacements)
    }

    return combinedReplacementMap
  }
  //PROCESS
  if (assistant === AI_ASSISTANTS.PROCESS_HELPER) {
    const userSnippets = get(completionSources, 'userSnippets', [])
    const instanceProperties = get(completionSources, 'instanceProperties', [])
    const isFormSave = get(completionSources, 'isFormSave', false)
    const replaceText = isFormSave ? 'this.instance.form.fields.' : 'this.instance.'
    let combinedReplacementMap = []

    if (userSnippets.length) {
      const userSnippetsReplacements = userSnippets.map((snippet) => {
        return {
          trigger: snippet.name,
          displayText: snippet.name,
          replaceText: snippet.code,
        }
      })

      combinedReplacementMap = combinedReplacementMap.concat(userSnippetsReplacements)
    }

    if (instanceProperties.length) {
      const instanceReplacements = instanceProperties.map((instanceKey) => {
        return {
          trigger: `instance.${instanceKey}`,
          displayText: `${replaceText}${instanceKey}`,
          replaceText: `${replaceText}${instanceKey}`,
        }
      })

      combinedReplacementMap = combinedReplacementMap.concat(instanceReplacements)
    }

    return processReplacementMap.concat(combinedReplacementMap)
  }

  //DEFAULT
  return []
}
